import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { LogIn, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export function LoginRequiredBody({ reason = "download", testid = "login-required" }) {
  const { login } = useAuth();
  const verb = reason === "buy" ? "comprar" : "descargar";
  return (
    <div className="text-center space-y-4 py-2" data-testid={testid}>
      <div className="w-14 h-14 rounded-full bg-red-600/15 border border-red-600/40 flex items-center justify-center mx-auto">
        <Lock className="w-6 h-6 text-red-500" />
      </div>
      <div>
        <div className="font-display font-black uppercase text-lg tracking-tight" data-testid={`${testid}-title`}>Debes iniciar sesión para {verb}</div>
        <p className="text-sm text-white/60 mt-2">Es gratis y solo tarda unos segundos: entra con tu cuenta de Google y tendrás acceso a todas las descargas, compras y a tu historial en «Mi música».</p>
      </div>
      <button type="button" onClick={() => login()} data-testid={`${testid}-login-button`}
        className="inline-flex items-center gap-2 btn-red text-white px-6 py-3 rounded-full font-semibold">
        <LogIn className="w-4 h-4" /> Iniciar sesión con Google
      </button>
    </div>
  );
}

export function LoginPromptModal() {
  const { loginPrompt, closeLoginPrompt } = useAuth();
  return (
    <Dialog open={!!loginPrompt} onOpenChange={(v) => !v && closeLoginPrompt()}>
      <DialogContent className="bg-[#0f0f14] border border-white/10 text-white w-[calc(100vw-2rem)] max-w-sm" data-testid="login-prompt-modal">
        <DialogHeader>
          <DialogTitle className="font-mono text-[10px] uppercase tracking-[0.3em] text-red-500">Acceso</DialogTitle>
        </DialogHeader>
        <LoginRequiredBody reason={loginPrompt || "download"} testid="login-prompt" />
      </DialogContent>
    </Dialog>
  );
}
